'use strict';

const $ = require('jquery');
const telegraph = require('telegraph-events');

/*
Slides have 5 events:
  add(slideshow, $el): after added to a slideshow
  beforeEnter(): before entering animation starts
  afterEnter(): after entering animation is done
  beforeLeave(): before leaving animation starts
  afterLeave(): after leaving animation is done

Example of telegraph event handler:
  var onAdd = function(slideshow, $el) { ...; };
  this.on('add', onAdd);
  this.off('add', onAdd);

Make sure not to override handlers, create new ones instead (with different names)!

See: https://github.com/dubrowgn/telegraph for documentation on event handlers
*/

module.exports = class {
  constructor(template, context = {}) {
    telegraph(this); // extends Slide with emit, on/off, etc

    // initialize fields
    this.$el = [];
    this._template = template;
    this._context = context;
    this._slideshow = undefined;
    // DOM events object, put DOM events in this thing, just like you would with backbone
    // e.g. 'click #selector': '_methodName' or 'submit #form': () => this.doSomething()
    this.domEvents = {};

    this._timer = 1;

    this.on('add', this._init);
    this.on('beforeEnter', this._registerDomEvents);
    this.on('afterLeave', this._unregisterDomEvents);
    this.on('beforeEnter', this._renderProgressBar);
    this.on('beforeEnter', this._delayNextButton);
  }

  reset() {
    // override as necessary
  }

  // this is always called before a slide is removed from the slideshow
  destroy() {
    this.off();
    this.$el.off();
    this.$el.remove();
  }

  toHtml(nSlides, currentIndex) {
    if (this._template === null) return '';

    var context = $.extend({}, this._context, {nSlides: nSlides, currentIndex: currentIndex});
    return this._template(context);
  }

  // SLIDE EVENTS

  _init(slideshow, $el) {
    this._slideshow = slideshow;
    this.$el = $el;
  }

  _registerDomEvents() {
    // parts of this shamelessly stolen from backbone source
    const selectorSplitter = /^(\S+)\s*(.*)$/;

    Object.keys(this.domEvents).forEach(key => {
      let func = this.domEvents[key];
      if (typeof func !== 'function')
        func = this[func];
      const [, events, selector] = key.match(selectorSplitter);
      this.$el.on(events, selector, func.bind(this));

      // TODO: namespace events, do a destroy version etc.
    });
  }

  _unregisterDomEvents() {
    this.$el.off();
  }

  _renderProgressBar() {
    const $progressBar = this.$el.find('.slideshow-progress');

    const start = this._slideshow.findIndex(require('./form-slide'));
    if (start - this._slideshow.currentIndex > 0 || $progressBar.length === 0)
      return;

    let ret = '';
    for (let i = start; i < this._slideshow.slides.length - 1; i++) {
      if (i === this._slideshow.currentIndex)
        ret += '<li class="active"></li>';
      else
        ret += '<li></li>';
    }
    ret += '</ul>';

    $progressBar.html(ret);
  }

  _delayNextButton() {
    $('.slideshow-btn-next').attr("disabled", true);
    $('.slideshow-btn-next').removeAttr("data-nav-next", false);
    $('.slideshow-btn-next').removeAttr("href", false);

    let countdown = this._timer;

    this._intervalHandler = setInterval(() => {
      countdown -= 1;
      if (countdown === 0) {
        $('.slideshow-btn-next').removeAttr("disabled", false);
        $('.slideshow-btn-next').attr("data-nav-next", true);
        $('.slideshow-btn-next').attr("href", "#");
      }
    }, 1000);
  }
};
